import React, { useState, useEffect } from 'react';
import { InputLabel, MenuItem } from '@mui/material';
import { withRouter } from 'react-router-dom';
import { SortContainer, SortForm, SortSelectStyled } from './searchbar.styles';
import { useDispatch, useSelector } from 'react-redux';
import { get, set } from 'global/lib/lodash';
import setFilter from 'redux/actions/setFilter';
import { setBodyOverflow } from 'global/hooks/useBodyOverflow';

const SortSelect = (props) => {
  const { options } = props;
  const dispatch = useDispatch();
  const split = get(props, 'location.pathname', '')
    .split('/')
    .filter((s) => s);
  const filter = useSelector((state) => get(state, ['filter', ...split]));
  const [selected, setSelected] = useState(get(filter, '_sort.sortBy', 0));

  const handleSelect = (e) => {
    const val = e.target.value;
    setSelected(val);
    if (filter) {
      dispatch(setFilter(split[0], split[1], set({ ...filter }, '_sort.sortBy', val)));
    }
    setBodyOverflow();
  };

  const sortBy = get(filter, '_sort.sortBy');

  useEffect(() => {
    setSelected(sortBy);
  }, [sortBy]);

  const showNone = get(props, 'showNone', false);

  return (
    <SortContainer>
      <SortForm variant='standard'>
        <InputLabel htmlFor="Standard-sort">Sort By</InputLabel>
        <SortSelectStyled value={selected} onChange={handleSelect} disableUnderline>
          {showNone && (
            <MenuItem key={'_none_'} value={undefined}>
              {'None'}
            </MenuItem>
          )}
          {(options || []).map((opt, i) => (
            <MenuItem key={i} value={opt.value || i}>
              {opt.title}
            </MenuItem>
          ))}
        </SortSelectStyled>
      </SortForm>
    </SortContainer>
  );
};

export const Sort = withRouter(SortSelect);
